import React from "react";
import GridLines from "@/components/site/GridLines";

export default function Why() {
  return (
    <>
      <section className="rf-why" id="why" data-testid="why">
        <div className="rf-wrap">
          <div className="rf-why__head">
            <p className="rf-label rf-label--onGreen">WHY RENAFLEX</p>
            <h2 className="rf-h2">
              Why builders, architects and applicators{" "}
              <br className="rf-br-d" />
              choose Renaflex
            </h2>
          </div>
        </div>
        <div className="rf-why__rule" />
        <div className="rf-why__rows">
          <GridLines tone="green" />
          <div className="rf-wrap">
            <div className="rf-why__grid">
              <div className="rf-why__cell">
                <h3 className="rf-cardTitle rf-cardTitle--onGreen">Clean execution</h3>
                <p className="rf-cardBody rf-cardBody--onGreen">
                  Less mess. Faster work. Better control <br className="rf-br-d" />on site.
                </p>
              </div>
              <div className="rf-why__cell">
                <h3 className="rf-cardTitle rf-cardTitle--onGreen">Smooth finish</h3>
                <p className="rf-cardBody rf-cardBody--onGreen">
                  A refined surface that supports better final outcomes.
                </p>
              </div>
              <div className="rf-why__cell">
                <h3 className="rf-cardTitle rf-cardTitle--onGreen">Versatile application</h3>
                <p className="rf-cardBody rf-cardBody--onGreen">
                  Use it across partitions, ceilings, panelling, cladding, furniture and more.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="rf-why__rule" />
        <div className="rf-why__tail" />
      </section>

      <div className="rf-facade" data-testid="facade">
        <picture>
          <source media="(max-width: 1023px)" srcSet="/assets/m-facade.png" />
          <img src="/assets/d-facade.png" alt="Fibre cement board facade on a modern building" />
        </picture>
      </div>
    </>
  );
}
